<template>
    <section class="container">
        <div class="row">
            <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                <adminSidenav></adminSidenav>
            </div>
            <div class="col-md-9 ml-sm-auto col-lg-10 px-4">
                <h2>활동 관리</h2>
<!--                <select v-model="page.size" @change="searchMember">-->
<!--                    <option value="5">5개씩보기</option>-->
<!--                    <option value="10">10개씩보기</option>-->
<!--                    <option value="20">20개씩보기</option>-->
<!--                    <option value="30">30개씩보기</option>-->
<!--                    <option value="40">40개씩보기</option>-->
<!--                    <option value="50">50개씩보기</option>-->
<!--                </select>-->
                <div class="input-group rounded-pill p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text"> 참여 멤버 있음</span>
                  </div>
                  <input  type="checkbox" class="form-control" v-model="activity.members">
                  <div class="input-group-prepend">
                    <span class="input-group-text"> 활동 리뷰 있음</span>
                  </div>
                  <input type="checkbox" class="form-control" v-model="activity.reviews">
                  <div class="input-group-prepend">
                    <span class="input-group-text"> 접수중</span>
                  </div>
                  <input type="checkbox" class="form-control" v-model="activity.activityJoinAbleNow">
                </div>

                <div class="input-group rounded-pill p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text"> 활동 상태</span>
                  </div>
                  <select class="form-control"  v-model="activity.status">
                    <option value="" selected="selected">전체</option>
                    <option value="prepare">모집중</option>
                    <option value="in_progress">진행중</option>
                    <option value="done">완료</option>
                  </select>

                  <div class="input-group-prepend">
                    <span class="input-group-text">활동 분류</span>
                  </div>
                  <select class="form-control" v-model="activity.category">
                    <option value="">모두</option>
                    <option v-bind:key="c.name" v-bind:value="c.code" v-for="c in $root.$children[0].category">{{c.name}}
                    </option>
                  </select>

                </div>
                <div class="input-group  rounded-pill p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">활동 년도</span>
                  </div>
                  <select class="form-control" v-model="activity.year">
                    <option value="">모두</option>
                    <option :value="y" v-for="y in $root.$children[0].getYears()">{{ y }}</option>
                  </select>

                    <div class="input-group-prepend">
                      <span class="input-group-text"> 활동명</span>
                    </div>
                    <input type="search" v-model="value" placeholder="활동검색"
                           aria-describedby="button-addon3" class="form-control bg-none border-1" @keyup.enter="clickCallback">

                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" v-on:click="clickCallback">
                        검색
                      </button>
                    </div>
                </div>

                총 {{totalCount}} 건
                <br/>
                <table class="table text-center">
                    <thead>
                    <tr>
                        <th class="d-none d-lg-table-cell">No</th>
                        <th class="d-none d-lg-table-cell" width="10%">분류</th>
                        <th>제목</th>
                        <th class="d-none d-lg-table-cell">[모집]기간</th>
                        <th class="d-none d-lg-table-cell">장소</th>
                        <th class="d-none d-lg-table-cell" width="5%">신청</th>
                        <th width="12%">승인/모집</th>
                        <th class="d-none d-lg-table-cell" width="5%">리뷰</th>
                        <th>접수</th>
                        <th>고정</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="activities.length == 0">
                        <th colspan="100%">활동이 없습니다.</th>
                    </tr>
                    <tr v-else v-for="activity in activities"> <!--  carousel-item active -->
                        <td class="d-none d-lg-table-cell">{{activity.id}}</td>
                        <td class="d-none d-lg-table-cell">{{activity.categoryName}}</td>
                        <td>
                            <router-link :to="{name : 'activityMemberList', params : { id : activity.id }}">{{activity.title}}</router-link>
                            <img style="cursor: pointer"  v-on:click="copyActivity(activity.id)" :src="require('@/assets/icon/btn_copy.png')">
                            <br>
                            <div class="progress bg-primary" style="height:8px;">
                                <div class="progress-bar" role="progressbar" :style="'background-color:red;width:' + requestedPercent(activity) + '%;'" :aria-valuenow="activity.memberCount" aria-valuemin="0" :aria-valuemax="activity.joinAblePersonCount"></div>
                                <div class="progress-bar bg-success" role="progressbar" :style="'width:' + parseInt(activity.memberCount/activity.joinAblePersonCount * 100) + '%;'" :aria-valuenow="activity.memberCount" aria-valuemin="0" :aria-valuemax="activity.joinAblePersonCount"></div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell ">
                          <span :class="{'text-primary': !$root.$children[0].moment().isAfter(activity.joinDueDate), 'text-danger': $root.$children[0].moment().isAfter(activity.joinDueDate)}">
                          [~{{$root.$children[0].dateFormat(activity.joinDueDate, 'YYYY.MM.DD HH:mm')}}] <br>

                          </span>

                          <span :class="{
                            'text-info': !$root.$children[0].moment().isAfter(activity.activityEndDate) ,
                            'text-danger':$root.$children[0].moment().isAfter(activity.activityEndDate),
                            'text-primary':$root.$children[0].moment().isAfter(activity.activityStartDate),
                          }">
                          {{$root.$children[0].dateFormat(activity.activityStartDate, 'YYYY.MM.DD')}}
                            {{$root.$children[0].dateFormat(activity.activityStartDate,'HH:mm')}} ~
                            {{$root.$children[0].dateFormat(activity.activityEndDate,'MM.DD HH:mm')}}
                            </span>
                        </td>
                        <td class="d-none d-lg-table-cell">{{activity.activityPlaceName}}</td>
                        <td class="d-none d-lg-table-cell"><span style="color:red;">{{activity.allMemberCount - activity.memberCount}}</span></td>
                        <td>
                            <span class="text-success">{{activity.memberCount}}</span> / <span class="text-primary">{{activity.joinAblePersonCount}}</span>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <span class="text-success">
                              <router-link :to="{name : 'activityShow', params : { id : activity.id }}">{{activity.reviewCount}}</router-link>
                            </span>
                        </td>
                        <td>
                            <!--{{activity.activityJoinAbleNow ? '모집중' : '신청불가'}}-->
                            <label>
                                <Toggle v-model="activity.activityJoinAbleNow" @input="updateActivityJoinAbleNow(activity)"/>
                            </label>
                        </td>
                        <td>
                            <label>
                                <Toggle v-model="activity.isFixedTop" @input="updateActivityFixedTop(activity)"/>
                            </label>
                        </td>
                    </tr>
                    </tbody>
                </table>
              <router-link class="btn btn-primary float-right" to="/activity/regist">활동 등록</router-link>
              <br>

              <paginate :page-count="totalPage" :click-handler="clickCallback" :prev-text="'<'" :next-text="'>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'"
                          :page-link-class="'page-link-item'"
                          :prev-class="'prev-item'"
                          :prev-link-class="'prev-link-item'"
                          :next-class="'next-item'"
                          :next-link-class="'next-link-item'"
                          :break-view-class="'break-view'"
                          :break-view-link-class="'break-view-link'">
                        <span slot="breakViewContent">
                          <svg width="16" height="4" viewBox="0 0 16 4">
                            <circle fill="#999999" cx="2" cy="2" r="2" />
                            <circle fill="#999999" cx="8" cy="2" r="2" />
                            <circle fill="#999999" cx="14" cy="2" r="2" />
                          </svg>
                        </span>
                </paginate>
            </div>
        </div>

    </section>

</template>

<script>
    import adminSidenav from '@/components/admin/Sidenav.vue'
    import Toggle from '@/components/admin/Toggle.vue'
    import moment from "moment";
    /* eslint-disable */
    export default {
        name: 'manageAct',
        data() {
            return {
              target:'title',
              value:'',
              query:'',
              activity: {
                category: '',
                status:'',
                year:'',
                /*
                activityJoinCost: '',
                minJoinLimitByLevel: '',
                maxJoinLimitByLevel: '',
                minJoinLimitByAge: '',
                maxJoinLimitByAge: '',
                activityDate: '',*/
                joinDueDate: '',
                activityStartDay: '',
                activityEndDay: '',
                activityJoinAbleNow:false,
                reviews:false,
                members:false,
              },
                activities: [],
                search: {
                    page: 0,
                    size: 10,
                    target: String,
                    value: String,
                    category: String
                },
                page:{
                    nowPage:0,
                    size:10,
                    sort:'id',
                    order:'desc',
                },
                totalCount : 0,
                totalPage : 0
            }
        },
        components: {
            adminSidenav, Toggle
        },
        methods: {
            getList() {
                let me = this;
                let u = new URLSearchParams(this.search).toString();

                let url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/search?${u}`;
                //console.log(u);
                this.axios.get(url)
                    .then(function (res) {
                        me.activities = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            makeQuery() {
              let query = `page=${this.page.nowPage}&size=${this.page.size}&sort=${this.page.sort},${this.page.order}&query=${this.target}:${this.value},`;
              query += !!this.activity.category ? `category:${this.activity.category},` : ""

              query += !!this.activity.year ? `activityStartDay>${parseInt(this.activity.year)-1}1231,` : ""
              query += !!this.activity.year ? `activityStartDay<${parseInt(this.activity.year)+1}0101,` : ""

              query += !!this.activity.activityJoinAbleNow ? `activityJoinAbleNow:${this.activity.activityJoinAbleNow},` : ""

              if(this.activity.reviews) query += `replies!REVIEW,`
              if(this.activity.members) query += `actMembers!all,`

              if(!!this.activity.status) {
                //this.activity.activityStartDay = moment().add(+1,'d').format('YYYYMMDD');
                //this.activity.activityEndDay = moment().add(-1,'d').format('YYYYMMDD');
                this.activity.activityStartDay = moment().add(+1,'d').format('yyyyMMDD');
                this.activity.activityEndDay = moment().format('yyyyMMDD');
                this.activity.joinDueDay = moment().format('yyyyMMDD');

                switch (this.activity.status) {
                  case 'prepare':
                    query += !!this.activity.joinDueDay ? `joinDueDay>${this.activity.joinDueDay},` : ""
                    break;
                  case 'in_progress':
                    query += !!this.activity.activityStartDay ? `activityStartDay<${this.activity.activityStartDay},` : ""
                    query += !!this.activity.activityEndDay ? `activityEndDay>${this.activity.activityEndDay},` : ""
                    break;
                  case 'done':
                   // query += !!this.activity.activityStartDay ? `activityStartDay<${this.activity.activityStartDay},` : ""
                    query += !!this.activity.activityEndDay ? `activityEndDay<${moment().add(+1,'d').format('yyyyMMDD')},` : ""
                    break;
                  default :
                    break;
                }
              }
              this.query = query;
            },
            getListWithPaging() {
              let me = this;
              this.makeQuery();
              this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/page?${this.query}`)
                    .then(function (res) {
                      me.activities = res.data.result;
                      me.totalCount = res.data.totalCount;
                      me.totalPage = res.data.totalPage;
                      me.page.nowPage = !!res.data.pageable.pageNumber ? res.data.pageable.pageNumber : 0 ;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },

            updateActivityJoinAbleNow(activity) {
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/activityJoinAbleNow`;
                //console.log(u);
                this.axios.put(url, activity)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('활동 수정', '수정되었습니다.')
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            updateActivityFixedTop(activity) {
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/fixedTop`;
                //console.log(u);
                this.axios.put(url, activity)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('활동 수정', '수정되었습니다.')
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            
            requestedPercent : function(activity) {
                let percent = parseInt((activity.allMemberCount - activity.memberCount)/activity.joinAblePersonCount * 100);
                return  percent > 100 ? 100 : percent;
            },
            copyActivity(activityId) {
                if(!confirm("활동을 복사하시겠습니까?")) return false;
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/copy/${activityId}`;
                //console.log(u);
                this.axios.post(url)
                    .then(function (res) {
                        console.log(res.data)
                        me.$root.$children[0].commonDialog('활동 복사', '활동이 복사 되었습니다. ')
                        me.$router.push({ name: 'activityModify', params: { id: res.data }})
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            clickCallback (pageNum) {
                this.page.nowPage = pageNum-1;
                this.getListWithPaging()
            }
        },
        computed: {

        },
        mounted() {
          //console.log(this.$route.params.status)
          if(this.$route.params.status)
            this.activity.status = this.$route.params.status;
          if(this.$route.params.year)
            this.activity.year = this.$route.params.year;
          if(this.$route.params.activityJoinAbleNow)
            this.activity.activityJoinAbleNow = this.$route.params.activityJoinAbleNow;
          if(this.$route.params.isReviewed)
            this.activity.reviews = this.$route.params.isReviewed;
          if(this.$route.params.isJoined)
            this.activity.members = this.$route.params.isJoined;
          if(this.$route.params.category)
            this.activity.category = this.$route.params.category;
          this.getListWithPaging();

        },
        created() {
        },

        watch: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table td, .table th {
    padding: 0!important;
    vertical-align: center!important;
}

label {
    display: inline-block;
    margin-top: 5px;
    margin-bottom: 0px;
}
</style>
